class Schedule {
  constructor(schedule) {
    this.schedule = schedule;
    this.todayName = this.#getDayName(this.#now);
  }
  
  #getDayName = (time) =>
  time.toLocaleString("en-us", { weekday: "long" }).toLowerCase();
  
  currentTime = () => {
    const date = new Date();
    const timeZone = 'Europe/Kiev'
    if (typeof date === 'string') {
      return new Date(
        new Date(date).toLocaleString('en-US', {
          timeZone,
        }),
      );
    }
  
    return new Date(
      date.toLocaleString('en-US', {
        timeZone,
      }),
    );

    // return this.#now
  }
  
  #now = this.currentTime();
  
  get tomorrowName() {
    const tmpDate = new Date(this.#now);
    tmpDate.setDate(tmpDate.getDate() + 1);
    return this.#getDayName(tmpDate);
  }

  // Input: day name
  // Output: [startTimeString, endTimeString]
  daySchedule(day) {
    const dayScheduleString = this.schedule[day];
    if (dayScheduleString.length) {
      return dayScheduleString[0]?.split("-");
    }
    return undefined;
  }

  get todaySchedule() {
    return this.daySchedule(this.todayName);
  }

  get nextWorkingDaySchedule() {
    return this.daySchedule(this.nextWorkingDay);
  }

  get isOpen() {
    if (!this.todaySchedule) {
      return false;
    }
    const [todayStartTimeString, todayEndTimeString] = this.todaySchedule;
    const todayStartTime = new Date(this.#now);
    todayStartTime.setHours(...todayStartTimeString.split(":"), 0);
    const todayEndTime = new Date(this.#now);
    todayEndTime.setHours(...todayEndTimeString.split(":"), 0);
    return todayStartTime < this.#now && this.#now < todayEndTime;
  }

  get nextWorkingDay() {
    const tmpDate = new Date(this.#now);
    const todayStartTime = new Date(this.#now);
    if (this.todaySchedule) {
      todayStartTime.setHours(...this.todaySchedule[0].split(":"), 0);
      if (tmpDate < todayStartTime) {
        return this.todayName;
      }
    }
    let maxLoopCount = 7;
    while (maxLoopCount > 0) {
      maxLoopCount -= 1;
      tmpDate.setDate(tmpDate.getDate() + 1);
      const nextWorkingDayName = this.#getDayName(tmpDate);
      if (this.schedule[nextWorkingDayName].length) {
        return nextWorkingDayName;
      }
    }
    return undefined;
  }

  get isNextWorkingDayTomorrow() {
    return this.nextWorkingDay === this.tomorrowName;
  }
}
export default Schedule;
